module.exports = __webpack_public_path__ + "static/media/GGMC_logo.92267505.png";